"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorTypes = exports.ALERT_ORIGIN_BACKEND = exports.ALERT_ORIGIN_FRONTEND = exports.ALERT_TYPE_DEFAULT = exports.ALERT_TYPE_INFO = exports.ALERT_TYPE_WARNING = exports.ALERT_TYPE_ERROR = void 0;
var ALERT_TYPE_ERROR = 'ERROR';
exports.ALERT_TYPE_ERROR = ALERT_TYPE_ERROR;
var ALERT_TYPE_WARNING = 'WARNING';
exports.ALERT_TYPE_WARNING = ALERT_TYPE_WARNING;
var ALERT_TYPE_INFO = 'INFO';
exports.ALERT_TYPE_INFO = ALERT_TYPE_INFO;
var ALERT_TYPE_DEFAULT = 'DEFAULT';
exports.ALERT_TYPE_DEFAULT = ALERT_TYPE_DEFAULT;
var ALERT_ORIGIN_FRONTEND = 'ALERT_ORIGIN_FRONTEND';
exports.ALERT_ORIGIN_FRONTEND = ALERT_ORIGIN_FRONTEND;
var ALERT_ORIGIN_BACKEND = 'ALERT_ORIGIN_BACKEND';
exports.ALERT_ORIGIN_BACKEND = ALERT_ORIGIN_BACKEND;
var errorTypes = {
  OUT_OF_RANGE: 'OutOfRange',
  REQUIRED: 'Required',
  UNKNOWN: 'Unknown'
};
exports.errorTypes = errorTypes;
//# sourceMappingURL=constants.js.map